import Axios from "axios";
import {
    SET_BANK_BRANCH_LIST,
    UNSET_BANK_BRANCH_LIST,
    SET_EDITING_BANK_BRANCH_LIST,
    UNSET_EDITING_BANK_BRANCH_LIST,
} from "@/store/mutation-types";
import { 
    getBankBranchList, 
    getBankBranchById,
    saveBankBranch,
    updateBankBranch,
} from "@/store/api";

// initial state
const state = {
    getBankBranchList: [],
    getEditingBankBranch: {},
};

const getters = {
    getBankBranchList(state) {
        return state.getBankBranchList;
    },
    getEditingBankBranch(state) {
        return state.getEditingBankBranch;
    },
};

const mutations = {
    [SET_BANK_BRANCH_LIST](state, data) {
        state.getBankBranchList = data;
    },
    [UNSET_BANK_BRANCH_LIST](state) {
        state.getBankBranchList = [];
    },
    [SET_EDITING_BANK_BRANCH_LIST](state, data) {
        state.getEditingBankBranch = data;
    },
    [UNSET_EDITING_BANK_BRANCH_LIST](state) {
        state.getEditingBankBranch = {};
    },
};

const actions = {
    saveBankBranch({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveBankBranch, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    updateBankBranch({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.put(`${updateBankBranch}/${data.branch_id}`, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getBankBranchList({ commit }) {
        return new Promise((resolve, reject) => {
        Axios.get(getBankBranchList)
            .then(function (response) {
            commit('SET_BANK_BRANCH_LIST', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_BANK_BRANCH_LIST');
            reject(error);
            });
        });
    },

    getBankBranchById({ commit }, data) {
        const getBankBranchRecordById = `${getBankBranchById}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getBankBranchRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

